import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendBlogPostBuilderFullGeneration,
  BackendQueryBlogFullGenerationArgs,
} from 'src/types/backend';

const MUTATION = gql`
  query BlogFullGeneration($id: ID!) {
    blogFullGeneration(id: $id) {
      taskErrors
      status
    }
  }
`;

type Variables = BackendQueryBlogFullGenerationArgs;
type Result = Pick<BackendBlogPostBuilderFullGeneration, 'taskErrors' | 'status'>;

export const queryBlogFullGeneration = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
